import {
  Button,
  Card,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Spin,
  Typography,
} from "antd";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import MainLayout from "../../../../../../components/layouts/MainLayout";
import TopContent from "../../../../../../components/layouts/TopContent";
import cnt from "../../../../../../services/definedConstant";
import { BOM } from "../../../../../../services/definedMethod";
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../../../../customer.config";
import { showCheckerApprovalModal } from "../../../../../../components/CheckerModal";

const { Text } = Typography;
const { TextArea } = Input;

function NewChequeBook(props) {
  const { userData } = props;
  const { session } = userData;
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    form.setFieldsValue({ accountNo: state?.accountNo });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  const onSubmit = (values) => {
    const payload = {
      ...values,
      locale: "en",
      dateFormat: "dd MMMM yyyy",
      method: "POST",
      session,
    };

    const url = `${apiConfig.Cheques}`;

    setLoading(true);
    BOM.FetchReqAction(
      payload,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.addChequeBookRequestMsg);
          form.resetFields();
          setLoading(false);
          navigate("/manage-cheque-book-request", { state: state });
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/manage-cheque-book-request", { state: state });
          setLoading(false);
        },
      },
    );
  };

  return (
    <MainLayout isEnableRightSidebar={false}>
      <TopContent
        pageTitle={labelConfig.newChequeBookRequest}
        pageItems={staticConfig.newChequeBookRequestBreadcrumbItems(state)}
        //  createPageTitle={labelConfig.createMoneyMarketBond}
      />
      <Card
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
          marginTop: 20,
        }}
      >
        <Spin spinning={loading}>
          <Form form={form} layout="vertical" onFinish={onSubmit}>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="accountNo"
                  label={<Text strong>Account No</Text>}
                  rules={[
                    {
                      required: true,
                      message: "Account No is required",
                    },
                  ]}
                >
                  <Input
                    className="of-bold-disable-input"
                    disabled
                    value={state?.accountNo}
                    style={{ width: "100%", height: "44px" }}
                  />
                </Form.Item>

                <Form.Item
                  name="deliveryMode"
                  label={<Text strong>Delivery Mode</Text>}
                  rules={[
                    {
                      required: true,
                      message: "Delivery Mode is required",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select Delivery Mode"
                    style={{ width: "100%", height: "44px" }}
                    options={[
                      { value: "courier", label: "Courier" },
                      { value: "branch", label: "Branch" },
                    ]}
                  />
                </Form.Item>

                <Form.Item
                  name="chequeLeaves"
                  label={<Text strong>Cheque Leaves</Text>}
                  rules={[
                    {
                      required: true,
                      message: "Cheque Leaves is required",
                    },
                  ]}
                >
                  <InputNumber
                    placeholder="0"
                    style={{ width: "100%", height: "44px" }}
                    min={1}
                    precision={0}
                  />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  name="deliveryAddress1"
                  label={<Text strong>Delivery Address 1</Text>}
                  rules={[
                    {
                      required: true,
                      message: "Delivery Address 1 is required",
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter Delivery Address 1"
                    style={{ width: "100%", height: "44px" }}
                  />
                </Form.Item>

                <Form.Item
                  name="deliveryAddress2"
                  label={<Text strong>Delivery Address 2</Text>}
                >
                  <Input
                    placeholder="Enter Delivery Address 2"
                    style={{ width: "100%", height: "44px" }}
                  />
                </Form.Item>

                <Form.Item
                  name="deliveryAddress3"
                  label={<Text strong>Delivery Address 3</Text>}
                >
                  <Input
                    placeholder="Enter Delivery Address 3"
                    style={{ width: "100%", height: "44px" }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col span={24}>
                <Form.Item
                  name="orderDetails"
                  label={<Text strong>Order Details</Text>}
                >
                  <TextArea placeholder="Enter Order Details" rows={4} />
                </Form.Item>
              </Col>
            </Row>

            <Row justify="end">
              <Col>
                <Form.Item label=" ">
                  <Button
                    htmlType="submit"
                    type="primary"
                    className="of-primaryBtnColor"
                    style={{ height: 44 }}
                  >
                    Request Cheque Book
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Spin>
      </Card>
    </MainLayout>
  );
}

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});

const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(NewChequeBook);
